import styled from 'styled-components'

import { CircleSelectMark, Pencil, PillButton, TypeStyle } from '@syconium/little-miss-figgy'

export const Header = styled.div`
  ${TypeStyle.css.headlineMicro}
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  font-weight: ${o => o.theme.typography.font.weight[700]};
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.wide};
  line-height: ${o => o.theme.spacing(4.5)};
  margin-top: ${o => o.theme.spacing(5)};
  margin-bottom: ${o => o.theme.spacing(2)};

  div {
    flex-basis: initial;
  }
`

export const TextArea = styled.textarea`
  ${TypeStyle.css.bodyDefault}
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.65px;
  box-sizing: border-box;
  padding: 9px 18px;
  width: 100%;
  height: 179px;
  resize: vertical;

  /* iOS Safari specific fix to prevent zoom */
  &:focus {
    @supports (-webkit-touch-callout: none) {
      font-size: 16px;
    }
  }
`

export const Container = styled.div``

export const Pill = styled(PillButton)`
  display: flex;
  padding: ${({ theme }) => theme.spacing(1.5, 3)};
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin: ${({ theme }) => theme.spacing(2)} 0;
  margin-left: auto;
  text-transform: none;
`

export const PencilIcon = styled(Pencil)`
  font-weight: 100;
`

export const CloseIcon = styled(CircleSelectMark)`
  &:hover {
    cursor: pointer;
  }
`
